import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Fade,
  TextField,
  Grid,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { setBooleanValue } from "../../../../reduxadmin/Reducers/dataHasBeenChanged.js";
import React, { useEffect, useState } from "react";
import OrderQueueCard from "../OrderQueueCard/OrderQueueCard.tsx";
import axios from "axios";
import OrderItemModal from "./components/OrderItemModal.tsx";
import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
import closeIcon from "./../../../../assets/icons/close.png";
import editIcon from "./../../../../assets/icons/editIcon.png";
import { ToastContainer, toast } from "react-toastify";
import chatImg from "./../../../../assets/icons/chat.png";

import clsx from "clsx";
import OrderTableDialog from "../OrderTableDialog/OrderTableDialog.tsx";
import moment from "moment";

import jwt_decode from "jwt-decode";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal.js";
import { CheckCircleIcon } from "lucide-react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const styleForOrderCancelationModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const otpModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "32%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "12px",
};

const OrderDetailsCardContent = ({
  order,
  reloadData,
  restaurantId,
  kitchenselected,
  type,
  readyFoodDetail,
}) => {
  const [showAll, setShowAll] = useState(true);
  const [nextStatus, setNextStatus] = useState("");
  const [prevStatus, setPrevStatus] = useState("");
  const [nextStatusId, setNextStatusId] = useState(0);
  const [prevStatusId, setPrevStatusId] = useState(0);
  const [openTableEdit, setOpenTableEdit] = useState(false);
  const [selectedSubOrder, setSelectedSubOrder] = useState({});
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const [IsWaitersView, setIsWaitersView] = useState(false);
  const [refundItems, setRefundItems] = useState([]);
  const [orderPaymentId, setOrderPaymentId] = useState<string>("");
  const [refundAmount, setRefundAmount] = useState<number>(0);

  const [openOrderCancelationModal, setOpenOrderCancelationModal] =
    React.useState(false);
  const handleOpenOrderCancelationModal = () =>
    setOpenOrderCancelationModal(true);
  const handleCloseOrderCancelationModal = () =>
    setOpenOrderCancelationModal(false);

  const [cencalationReasons, setCencalationReasons] = useState([]);
  const [selectCencalationReason, setSelectCencalationReason] = useState(null);
  const [remarks, setRemarks] = useState("N/A");
  const [openOTPModal, setOpenOTPModal] = useState(false);
  const [currentSubOrderForOTP, setCurrentSubOrderForOTP] = useState(null);
  const [otpValue, setOtpValue] = useState("");
  const [otpError, setOtpError] = useState("");
  const [isVerifyingOTP, setIsVerifyingOTP] = useState(false);
  const [userId, setuserId] = useState();
  const token = jwt_decode(localStorage.getItem("gotasteadmintoken"));
  useEffect(() => {
    setuserId(token?.UserId);
  }, [token]);

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  const formatTime = (dateTimeString) => {
    if (dateTimeString) {
      const normalizedDateTimeString = dateTimeString.replace(/\.\d+/, "");
      const dateObject = new Date(normalizedDateTimeString);
      if (isNaN(dateObject)) return "Invalid Date";
      return dateObject.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    }
    return "N/A";
  };

  const handleOrderStatusChange = async (nextStatusIdFromClickEvent) => {
    dispatch(setBooleanValue(true));
    try {
      const kitchenIds = order?.kitchenViews.map((x) => x.kitchenId);
      const foundWaiterKitchen = kitchenselected?.find(
        (data) => String(data.title) === String("Waiter View"),
      );
      if (
        foundWaiterKitchen &&
        type === "preparing" &&
        nextStatusIdFromClickEvent === 1
      ) {
        const foundOnReady = readyFoodDetail.find((x) => x.id == order.id);
        if (foundOnReady) {
          toast.error("Order Found On Ready", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          return;
        }
      }
      await axios
        .post(
          `${process.env.REACT_APP_SECRET}/api/QueueManagement/InsertIntoQueueManagementTableByRestaurantIdFromStatusCodeAndToStatusCode?fromStatusCode=${order.toStatus}&toStatusCode=${nextStatusIdFromClickEvent}&orderId=${order.id}`,
          kitchenIds,
        )
        .then(() => {
          reloadData();
        });
    } catch (error) {
      console.log(error);
    }
  };

  const getNextStatus = (prop: any) => {
    switch (prop) {
      case "Preparing":
        setNextStatus("Ready");
        setPrevStatus("Pending");
        setNextStatusId(6);
        setPrevStatusId(1);
        break;
      case "Pending":
        setNextStatus("Preparing");
        setPrevStatus("Queue");
        setNextStatusId(5);
        setPrevStatusId(13);
        break;
      case "Queue":
        setNextStatus("Pending");
        setPrevStatus("None");
        setNextStatusId(1);
        setPrevStatusId(0);
        break;
      case "Ready":
        setNextStatus("None");
        setPrevStatus("Preparing");
        setNextStatusId(0);
        setPrevStatusId(5);
        break;
      default:
        setNextStatus("None");
        setPrevStatus("None");
        setNextStatusId(0);
        setPrevStatusId(0);
        break;
    }
  };

  useEffect(() => {
    getNextStatus(order.toStatusData);
  }, [order]);

  useEffect(() => {
    const foundWaiterKitchen = kitchenselected?.find(
      (data) => String(data.title) === String("Waiter Kitchen"),
    );
    setIsWaitersView(!!foundWaiterKitchen);
  }, [kitchenselected]);

  const getLastFourDigits = (id) => id.toString().slice(-6);

  const loadCancelationReasons = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/OrderCancelationReason`,
      );
      const list = res.data.map((dt) => ({
        id: dt.id,
        title: dt.cancelationReason,
      }));
      setCencalationReasons(list);
    } catch (err) {
      console.error("Failed to load cancellation reasons", err);
    }
  };

  // extract from order object
  function extractRefundItems(order: any) {
    const kitchenViews = order?.kitchenViews;
    if (!Array.isArray(kitchenViews) || kitchenViews.length === 0) return [];

    // Process all kitchenViews → all subOrders → all valid items
    const refundItems = kitchenViews.flatMap((kitchenView) => {
      const subOrders = kitchenView?.subOrders;
      if (!Array.isArray(subOrders) || subOrders.length === 0) return [];

      return subOrders.flatMap((subOrder) => {
        const items = subOrder.orderItemDetailViews;
        if (!Array.isArray(items)) return [];

        return items
          .filter((item) => item.qty > 0)
          .map((item) => {
            // Map addons (if any)
            const addonPayloads = (item.orderAddons || []).map((addon: any) => {
              // Map options (if any)
              const optionPayloads = (addon.orderOptions || []).map(
                (option: any) => {
                  const subOptionQuantity: number = option.qty;

                  // Map subOptions (if any)
                  const subOptionPayloads = (option.orderSubOptions || []).map(
                    (subOption: any) => ({
                      subOptionId: subOption.id,
                      subOptionPrice: subOption.totalPrice,
                      subOptionQty: subOptionQuantity,
                    }),
                  );

                  return {
                    optionId: option.id,
                    optionPrice: option.totalPrice,
                    optionQty: option.qty,
                    subOptions:
                      subOptionPayloads.length > 0 ? subOptionPayloads : null,
                  };
                },
              );

              return {
                addOnId: addon.id,
                addOnPrice: addon.totalPrice,
                addOnTipsAmount: addon.addOnTipsAmount,
                addOnServiceChargeAmount: addon.addOnServiceChargeAmount,
                addOnServiceChargeVatAmount: addon.addOnServiceChargeVatAmount,
                addOnQuantity: addon.qty,
                options: optionPayloads.length > 0 ? optionPayloads : null,
              };
            });

            // Compute total price = base + vat + sd, then × qty
            const unitTotal =
              (item.basePrice || 0) +
              (item.vatInAmount || 0) +
              (item.sdInAmount || 0);
            const totalPrice = unitTotal * (item.qty || 1);

            return {
              orderItemId: item.id,
              totalPrice: totalPrice,
              tipsAmount: item.tipsAmount,
              serviceChargeAmount: item.serviceChargeAmount,
              serviceChargeVatAmount: item.serviceChargeVatAmount,
              quantity: item.qty,
              initialQuantity: item.qty,
              addOns: addonPayloads.length > 0 ? addonPayloads : null,
            };
          });
      });
    });

    return refundItems;
  }

  // Helper function to fetch order pricing details
  const fetchOrderPricingDetails = async (orderId: string) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/OrderRefund/GetOrderPricingDetails/${orderId}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching order pricing details:", error);
      throw error;
    }
  };

  const handleOrderCancel = async (orderId: string) => {
    let enrichedOrder = { ...order };

    try {
      const pricingData = await fetchOrderPricingDetails(orderId);

      // console.log("114: ", JSON.stringify(pricingData));

      const paymentId = pricingData[0]?.orderPaymentId;
      const refundAmount = pricingData[0]?.refundAmount;

      // Build a map of refund item data by orderItemId for quick lookup
      const refundItemMap = {};
      if (pricingData?.refundItems) {
        pricingData.refundItems.forEach((item: any) => {
          refundItemMap[item.orderItemId] = item;
        });
      }

      // Enrich the order's kitchenViews → subOrders → orderItemDetailViews with pricing data
      enrichedOrder = {
        ...order,
        kitchenViews: order.kitchenViews?.map((kitchenView) => ({
          ...kitchenView,
          subOrders: kitchenView.subOrders?.map((subOrder) => ({
            ...subOrder,
            orderItemDetailViews: subOrder.orderItemDetailViews?.map((item) => {
              const refundItem = refundItemMap[item.id];
              if (refundItem) {
                return {
                  ...item,
                  tipsAmount: refundItem.tipsAmount ?? 0,
                  serviceChargeAmount: refundItem.serviceChargeAmount ?? 0,
                  serviceChargeVatAmount:
                    refundItem.serviceChargeVatAmount ?? 0,
                  // Optionally attach addOn pricing too
                  orderAddons: item.orderAddons?.map((addon) => {
                    const matchingAddon = refundItem.addOns?.find(
                      (a) => a.addOnId === addon.id,
                    );
                    return {
                      ...addon,
                      addOnTipsAmount: matchingAddon?.addOnTipsAmount ?? 0,
                      addOnServiceChargeAmount:
                        matchingAddon?.addOnServiceChargeAmount ?? 0,
                      addOnServiceChargeVatAmount:
                        matchingAddon?.addOnServiceChargeVatAmount ?? 0,
                    };
                  }),
                };
              }
              return item;
            }),
          })),
        })),
      };

      setOrderPaymentId(paymentId);
      setRefundAmount(refundAmount);
    } catch (error) {
      toast.error(
        "Failed to load refund details. Proceeding with cancellation.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        },
      );
    }

    loadCancelationReasons();
    setOpenOrderCancelationModal(true);
    // console.log(JSON.stringify(order));
    // console.log(JSON.stringify(enrichedOrder));

    const items = extractRefundItems(enrichedOrder);
    setRefundItems(items);
    // console.log("Extracted refundItems:", JSON.stringify(items));
  };

  // updated function for cancelling order
  const handleCancelOrder = async () => {
    const obj = {
      id: 0,
      orderId: order.id,
      statusId: "IS006",
      isRefunded: true,
      cancelationReasonId: selectCencalationReason?.id ?? "CR007",
      cancelationReason: selectCencalationReason?.title ?? "Not Provided",
      remarks: remarks,
      restaurantId: restaurantId,
      kitchenId: order.kitchenId,
    };

    try {
      // Step 1: Cancel the order
      const cancelResponse = await axios.post(
        `${process.env.REACT_APP_SECRET}/api/Order/CancelOrder`,
        obj,
      );

      toast.success("Order successfully canceled", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      // Step 2: Call the refund API
      const payload = {
        orderPaymentId: orderPaymentId,
        orderStatus: "Transaction/FullRefund",
        refundTypeId: "1",
        refundFromOrderId: "",
        refundAmount: refundAmount,
        refundReasonDescription:
          selectCencalationReason.title || "Not Provided",
        creatorId: jwt_decode(localStorage.getItem("gotasteadmintoken")).UserId,
        refundItems,
        processingType: "Bank", // Bank OR Card
        emailAddress: "demoEmail",
        refundStatus: "RS002",
      };

      const refundResponse = await axios.post(
        `${process.env.REACT_APP_SECRET}/api/OrderRefund/OrderRefundReversal`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );

      const refundMessage = refundResponse.data;

      if (
        refundMessage === "Full Refund Request Successfull" ||
        refundMessage === "Partial Refund Successfull" ||
        refundMessage === "Full Refund Request Successfull without Addon"
      ) {
        toast.success(refundMessage);
      } else if (
        refundMessage ===
        "Data already exists for this OrderPaymentId and RefundTypeId."
      ) {
        toast.error("Already full refunded!");
      } else if (refundMessage === "This order is already full refunded!") {
        toast.error(refundMessage);
      } else {
        toast.warning(refundMessage);
      }

      // Close modal and reload
      setOpenOrderCancelationModal(false);
      reloadData();
    } catch (error: any) {
      console.error("Error during order cancellation or refund:", error);
      toast.error(
        "Error while processing cancellation/refund: " +
          (error?.message || "Unknown error"),
      );
    }
  };

  const handleOrderStatusChangeAtServe = async () => {
    try {
      const kitchenIds = order?.kitchenViews.map((x) => x.kitchenId);
      let subOrderId = null;

      if (order?.kitchenViews?.length) {
        for (const kitchenView of order.kitchenViews) {
          const dineInSubOrder = kitchenView.subOrders?.find(
            (subOrder) => subOrder.orderTypeName === "In-Store",
          );
          if (dineInSubOrder) {
            subOrderId = dineInSubOrder.id;
            break;
          }
        }
      }

      await axios
        .post(
          `${process.env.REACT_APP_SECRET}/api/Order/InsertIntoQueueManagementTableByServe?fromStatusCode=6&toStatusCode=15&orderId=${order.id}&fromTable=qe_Ready&subOrderId=${subOrderId}&restaurantId=${restaurantId}`,
          kitchenIds,
        )
        .then(() => {
          toast.success("Order Served", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          reloadData();
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOrderStatusChangeAtServedToReady = async () => {
    try {
      const kitchenIds = order?.kitchenViews.map((x) => x.kitchenId);
      // Find first In-Store subOrder for reversal
      let subOrderId = null;
      if (order?.kitchenViews?.length) {
        for (const kitchenView of order.kitchenViews) {
          const dineInSubOrder = kitchenView.subOrders?.find(
            (subOrder) => subOrder.orderTypeName === "In-Store",
          );
          if (dineInSubOrder) {
            subOrderId = dineInSubOrder.id;
            break;
          }
        }
      }

      await axios
        .post(
          `${process.env.REACT_APP_SECRET}/api/Order/InsertIntoQueueManagementTableByServe?fromStatusCode=15&toStatusCode=6&orderId=${order.id}&fromTable=qe_Ready&subOrderId=${subOrderId}&restaurantId=${restaurantId}`,
          kitchenIds,
        )
        .then(() => {
          toast.success("Order Status Reverted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          reloadData();
          setopenConfirmaitonModal(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOrderStatusChangeAtCollect = async () => {
    try {
      const kitchenIds = order?.kitchenViews.map((x) => x.kitchenId);
      let subOrderId = null;

      if (order?.kitchenViews?.length) {
        for (const kitchenView of order.kitchenViews) {
          const collectableSubOrder = kitchenView.subOrders?.find(
            (subOrder) =>
              subOrder.orderTypeName === "Delivery" ||
              subOrder.orderTypeName === "Collection",
          );
          if (collectableSubOrder) {
            subOrderId = collectableSubOrder.id;
            break;
          }
        }
      }

      await axios
        .post(
          `${process.env.REACT_APP_SECRET}/api/Order/InsertIntoQueueManagementTableByServe?fromStatusCode=6&toStatusCode=17&orderId=${order.id}&fromTable=qe_Ready&subOrderId=${subOrderId}&restaurantId=${restaurantId}`,
          kitchenIds,
        )
        .then(() => {
          toast.success("Order Collected", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          reloadData();
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOrderStatusChangeAtCollected = async () => {
    try {
      const kitchenIds = order?.kitchenViews.map((x) => x.kitchenId);
      let subOrderId = null;

      if (order?.kitchenViews?.length) {
        for (const kitchenView of order.kitchenViews) {
          const collectableSubOrder = kitchenView.subOrders?.find(
            (subOrder) =>
              subOrder.orderTypeName === "Delivery" ||
              subOrder.orderTypeName === "Collection",
          );
          if (collectableSubOrder) {
            subOrderId = collectableSubOrder.id;
            break;
          }
        }
      }

      await axios
        .post(
          `${process.env.REACT_APP_SECRET}/api/Order/InsertIntoQueueManagementTableByServe?fromStatusCode=17&toStatusCode=6&orderId=${order.id}&fromTable=qe_Ready&subOrderId=${subOrderId}&restaurantId=${restaurantId}`,
          kitchenIds,
        )
        .then(() => {
          toast.success("Order Status Reverted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          reloadData();
        });
    } catch (error) {
      console.log(error);
    }
  };

  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);

  return (
    <div>
      <ToastContainer />
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"This action will set order status to ready?"}
        open={openConfirmaitonModal}
        onyes={handleOrderStatusChangeAtServedToReady}
        close={() => setopenConfirmaitonModal(false)}
      />

      <div
        className="d-flex flex-column p-2"
        style={{
          borderBottom: "1px solid #f1f1f1",
          gap: "6px",
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <Typography
            className="orderQueueCardTitle"
            style={{ fontWeight: "600", fontSize: "1rem" }}
          >
            #Order {getLastFourDigits(order.id)}
          </Typography>

          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <Tooltip
              title={
                order?.creationDate
                  ? moment(order.creationDate).format("DD/MM/YYYY")
                  : ""
              }
            >
              <Typography sx={{ color: "#8a8d91", fontSize: "12px" }}>
                {moment(order.creationDate).format("DD/MM/YYYY")}{" "}
                {formatTime(order?.creationDate)}
              </Typography>
            </Tooltip>

            <div
              onClick={() => toast("Upcoming Feature")}
              style={{ cursor: "pointer" }}
            >
              <img src={chatImg} style={{ width: "1rem", opacity: 0.7 }} />
            </div>
          </div>
        </div>

        <div>
          <span
            style={{
              background: "linear-gradient(135deg, #ff6b35, #ff9a3c)",
              color: "#fff",
              padding: "5px 12px",
              borderRadius: "20px",
              fontWeight: "600",
              fontSize: "0.8rem",
              boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
              letterSpacing: "0.3px",
            }}
          >
            Order #{order.orderNo}
          </span>
        </div>
      </div>
      <hr className="pt-0 mt-1 w-100" />

      <div
        className="d-flex"
        style={{ flexDirection: "column", gap: "10px", margin: "10px" }}
      >
        {order?.kitchenViews?.length > 0 &&
          order?.kitchenViews?.map((food, index) => (
            <Card
              key={index}
              sx={{ paddingBottom: "0px", marginBottom: "0px" }}
            >
              <CardContent
                sx={{
                  paddingBottom: "10px !important",
                  padding: "0px !important",
                }}
              >
                {/* Kitchen name & Status */}
                <div
                  className="d-flex"
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    padding: "10px",
                  }}
                >
                  <Typography className="orderQueueCardTableNo">
                    {food.kitchenName}
                  </Typography>
                  <div
                    className="d-flex justify-content-between pt-1 align-items-center"
                    style={{ flexDirection: "column" }}
                  >
                    <Chip
                      label={food.toStatusData}
                      className={
                        food.toStatusData === "Queue"
                          ? "queue-status"
                          : food.toStatusData === "Pending"
                            ? "pending-status"
                            : food.toStatusData === "Preparing"
                              ? "preparing-status"
                              : "ready-status"
                      }
                    />
                  </div>
                </div>

                {food.subOrders.map((subOrder, i) => {
                  const itemsToShow = showAll
                    ? subOrder.orderItemDetailViews
                    : subOrder.orderItemDetailViews.slice(0, 2);

                  // Determine type explicitly
                  const isDeliveryOrCollection =
                    subOrder.orderTypeName === "Delivery" ||
                    subOrder.orderTypeName === "Collection";
                  const isInStore = subOrder.orderTypeName === "In-Store";

                  const subOrderHasItem =
                    subOrder.orderItemDetailViews.length > 0;

                  return (
                    <>
                      {subOrderHasItem && (
                        <div key={i}>
                          <div className="OrderItemsDiv">
                            <hr className="pt-0 mt-1 w-100" />

                            {/* Action Buttons */}
                            <div
                              className="d-flex mb-2"
                              style={{
                                flexDirection: "row",
                                justifyContent: "end",
                                gap: "10px",
                                alignItems: "center",
                              }}
                            >
                              {isDeliveryOrCollection &&
                                subOrder.isAuthenticatedForDelivery ===
                                  true && (
                                  <div
                                    style={{
                                      color: "#4caf50",
                                      fontSize: "18px",
                                      lineHeight: 1,
                                    }}
                                  >
                                    <CheckCircleIcon
                                      sx={{
                                        color: "#4caf50",
                                        fontSize: 22,
                                      }}
                                    />
                                  </div>
                                )}

                              {food.toStatusData !== "Queue" &&
                                food.toStatusData !== "Pending" &&
                                food.toStatusData !== "Preparing" && (
                                  <>
                                    {/* In-Store → Serve / Served */}
                                    {isInStore && (
                                      <div
                                        style={{ cursor: "pointer" }}
                                        className="serveDiv"
                                        onClick={() => {
                                          if (
                                            subOrder.toStatusDataSO === "15"
                                          ) {
                                            setopenConfirmaitonModal(true);
                                          } else {
                                            handleOrderStatusChangeAtServe();
                                          }
                                        }}
                                      >
                                        <Chip
                                          label={
                                            subOrder.toStatusDataSO === "15"
                                              ? "Served"
                                              : "Serve"
                                          }
                                          className={
                                            subOrder.toStatusDataSO === "15"
                                              ? "served"
                                              : "serve"
                                          }
                                        />
                                      </div>
                                    )}

                                    {/* Food Items */}
                                    {itemsToShow.map((item, i) => {
                                      // return (
                                      //   <React.Fragment key={i}>
                                      //     <OrderQueueCard
                                      //       ItemDetails={item}
                                      //       orderId={food.orderId}
                                      //       from={order.toStatusData}
                                      //       handleOrderStatusChange={
                                      //         handleOrderStatusChange
                                      //       }
                                      //       index={i}
                                      //       reload={reloadData}
                                      //       nextStatusId={nextStatusId}
                                      //       restaurantId={restaurantId}
                                      //       isWaitersView={IsWaitersView}
                                      //     />
                                      //     <hr className="pt-0 mt-1 mb-1 w-100" />
                                      //   </React.Fragment>
                                      // );
                                    })}
                                    {/* Delivery or Collection → Collect / Collected */}
                                    {isDeliveryOrCollection && (
                                      <div
                                        style={{ cursor: "pointer" }}
                                        className="serveDiv"
                                        onClick={() => {
                                          if (
                                            subOrder.toStatusDataSO === "17"
                                          ) {
                                            handleOrderStatusChangeAtCollected();
                                          } else if (
                                            subOrder.isAuthenticatedForDelivery
                                          ) {
                                            handleOrderStatusChangeAtCollect();
                                          } else {
                                            // ✅ Open OTP modal instead of directly collecting
                                            setCurrentSubOrderForOTP(subOrder);
                                            setOpenOTPModal(true);
                                            setOtpError("");
                                          }
                                        }}
                                      >
                                        <Chip
                                          label={
                                            subOrder.toStatusDataSO === "17"
                                              ? "Collected"
                                              : "Collect"
                                          }
                                          className={
                                            subOrder.toStatusDataSO === "17"
                                              ? "served"
                                              : "serve"
                                          }
                                        />
                                      </div>
                                    )}
                                  </>
                                )}

                              {/* Order Type Chip */}
                              <Chip
                                label={
                                  subOrder.orderTypeName === "Delivery" ? (
                                    <span
                                      className="d-flex"
                                      style={{ gap: "3px" }}
                                    >
                                      {subOrder.orderTypeName}
                                    </span>
                                  ) : subOrder.orderTypeName ===
                                    "Collection" ? (
                                    <span
                                      className="d-flex"
                                      style={{ gap: "3px" }}
                                    >
                                      {subOrder.orderTypeName}
                                    </span>
                                  ) : isInStore ? (
                                    <span
                                      className="d-flex"
                                      style={{ gap: "3px", cursor: "pointer" }}
                                      onClick={() => {
                                        setOpenTableEdit(true);
                                        setSelectedSubOrder(subOrder);
                                      }}
                                    >
                                      {subOrder.orderTypeName}{" "}
                                      <img
                                        src={editIcon}
                                        alt="Edit Icon"
                                        style={{
                                          width: "1.2rem",
                                          padding: "3px",
                                        }}
                                      />
                                    </span>
                                  ) : (
                                    <span>
                                      {subOrder.orderTypeName || "Unknown"}
                                    </span>
                                  )
                                }
                                className={clsx({
                                  delivery:
                                    subOrder.orderTypeName === "Delivery",
                                  collection:
                                    subOrder.orderTypeName === "Collection",
                                  dineIn: isInStore,
                                })}
                              />
                            </div>

                            {/* Food Items */}
                            {itemsToShow.map((item, idx) => (
                              <React.Fragment key={idx}>
                                <OrderQueueCard
                                  ItemDetails={item}
                                  orderId={food.orderId}
                                  from={order.toStatusData}
                                  handleOrderStatusChange={
                                    handleOrderStatusChange
                                  }
                                  index={idx}
                                  reload={reloadData}
                                  nextStatusId={nextStatusId}
                                  restaurantId={restaurantId}
                                  isWaitersView={IsWaitersView}
                                />
                                <hr className="pt-0 mt-1 mb-1 w-100" />
                              </React.Fragment>
                            ))}

                            {/* Show more/less */}
                            {subOrder.orderItemDetailViews.length > 2 && (
                              <div
                                className="d-flex justify-content-center"
                                style={{ cursor: "pointer" }}
                                onClick={toggleShowAll}
                              >
                                {showAll ? (
                                  <span>▲ Show Less</span>
                                ) : (
                                  <span>▼ Show More</span>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              </CardContent>
            </Card>
          ))}
      </div>

      {IsWaitersView === false && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "space-between",
            padding: ".9rem",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Button
              variant="contained"
              style={{
                backgroundColor: "#4E4E4E",
                color: "#FFFFFF",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                textTransform: "none",
                borderRadius: "20px",
                flex: "1",
                fontSize: "12px",
              }}
              onClick={handleOpen}
            >
              See Details
            </Button>

            {nextStatus !== "None" ? (
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#d0efdb",
                  color: "#13b04c",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  textTransform: "none",
                  borderRadius: "20px",
                  flex: "1",
                  textWrap: "nowrap",
                  fontSize: "12px",
                }}
                onClick={() => handleOrderStatusChange(nextStatusId)}
              >
                Move to {nextStatus}
              </Button>
            ) : (
              prevStatus !== "None" && (
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#FAEBD7",
                    color: "#F4A460",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    textTransform: "none",
                    borderRadius: "20px",
                    flex: "1",
                    textWrap: "nowrap",
                    fontSize: "12px",
                  }}
                  onClick={() => handleOrderStatusChange(prevStatusId)}
                >
                  Back to {prevStatus}
                </Button>
              )
            )}
          </div>

          {nextStatus !== "None" && prevStatus !== "None" && (
            <Button
              variant="contained"
              style={{
                backgroundColor: "#FAEBD7",
                color: "#F4A460",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                textTransform: "none",
                borderRadius: "20px",
                width: "100%",
                textWrap: "nowrap",
                fontSize: "12px",
              }}
              onClick={() => handleOrderStatusChange(prevStatusId)}
            >
              Back to {prevStatus}
            </Button>
          )}

          <Button
            variant="contained"
            style={{
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              textTransform: "none",
              borderRadius: "20px",
              width: "100%",
              textWrap: "nowrap",
              fontSize: "12px",
              color: "white",
              backgroundColor: "#ef5350",
            }}
            onClick={() => handleOrderCancel(order.id)}
          >
            Cancel Orders
          </Button>
        </div>
      )}

      {/* Modals */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
      >
        <Fade in={open}>
          <Box sx={{ ...style, maxHeight: "80vh", overflowY: "auto" }}>
            <div className="d-flex justify-content-between align-items-center">
              <h5 style={{ color: "#2a7fd4" }}>GoTaste:- Order Details</h5>
              <Button onClick={handleClose}>
                <img
                  src={closeIcon}
                  alt="close icon"
                  style={{ width: "1rem" }}
                />
              </Button>
            </div>
            <div
              className="d-flex"
              style={{ justifyContent: "center", flexWrap: "wrap" }}
            >
              <OrderItemModal
                orderDetails={order}
                reload={reloadData}
                from={"Modal"}
              />
            </div>
            <Grid
              md={12}
              sx={{
                display: "flex",
                justifyContent: "end",
                gap: "10px",
                marginTop: "1rem",
              }}
            >
              <Button variant="outlined" color="error" onClick={handleClose}>
                Close
              </Button>
            </Grid>
          </Box>
        </Fade>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openOrderCancelationModal}
        onClose={handleCloseOrderCancelationModal}
      >
        <Fade in={openOrderCancelationModal}>
          <Box
            sx={{
              ...styleForOrderCancelationModal,
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <h5 style={{ color: "#2a7fd4" }}>
                GoTaste:- Cancel Order No: #{getLastFourDigits(order.id)}
              </h5>
              <Button onClick={handleCloseOrderCancelationModal}>
                <img
                  src={closeIcon}
                  alt="close icon"
                  style={{ width: "1rem" }}
                />
              </Button>
            </div>
            <br />

            <Grid container>
              <Grid xs={12} md={12} sx={{ marginTop: ".8rem" }}>
                <AutoCompleteMultiSelect
                  id={33}
                  placeholder={"Select Cancelation Reason (Optional)"}
                  datas={cencalationReasons}
                  value={(res) => setSelectCencalationReason(res)}
                />
              </Grid>
              <Grid xs={12} md={12} sx={{ marginTop: ".8rem" }}>
                <TextAreaComponents
                  id={1}
                  value={(res) => setRemarks(res)}
                  label={"Remarks (Optional)"}
                />
              </Grid>
              <Grid
                md={12}
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "10px",
                  marginTop: "1rem",
                }}
              >
                <Button
                  variant="outlined"
                  color="success"
                  onClick={handleCancelOrder}
                >
                  Cancel Item
                </Button>
                <Button
                  variant="Outlined"
                  color="error"
                  onClick={handleCloseOrderCancelationModal}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
      {/* OTP Verification Modal */}
      <Modal
        aria-labelledby="otp-verification-modal-title"
        aria-describedby="otp-verification-modal-description"
        open={openOTPModal}
        onClose={() => {
          setOpenOTPModal(false);
          setOtpValue("");
          setOtpError("");
          setCurrentSubOrderForOTP(null);
          setIsVerifyingOTP(false);
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
      >
        <Fade in={openOTPModal}>
          <Box sx={otpModalStyle}>
            {/* Modal Header */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <Typography
                id="otp-verification-modal-title"
                variant="h6"
                sx={{
                  color: "#2a7fd4",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <span>🔐</span> Verify Order Collection
              </Typography>
              <Button
                onClick={() => {
                  setOpenOTPModal(false);
                  setOtpValue("");
                  setOtpError("");
                  setCurrentSubOrderForOTP(null);
                  setIsVerifyingOTP(false);
                }}
                sx={{ minWidth: "auto", padding: "4px" }}
              >
                <img src={closeIcon} style={{ width: "1.2rem" }} alt="Close" />
              </Button>
            </div>

            {/* OTP Input Field */}
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="body2"
                sx={{ mb: 1, textAlign: "center", color: "#56595B" }}
              >
                Enter the 5-digit OTP provided by the customer
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "8px",
                  maxWidth: "300px",
                  margin: "0 auto",
                }}
              >
                {Array.from({ length: 5 }).map((_, index) => (
                  <TextField
                    key={index}
                    type="text"
                    inputProps={{
                      maxLength: 1,
                      style: {
                        fontSize: "1.5rem",
                        textAlign: "center",
                        padding: "0",
                        height: "48px",
                        width: "48px",
                      },
                    }}
                    value={otpValue[index] || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d$/.test(value) || value === "") {
                        const newOtp = otpValue.split("");
                        newOtp[index] = value;
                        setOtpValue(newOtp.join(""));

                        // Auto-focus next field
                        if (value && index < 4) {
                          document
                            .getElementById(`otp-input-${index + 1}`)
                            .focus();
                        }
                      }
                    }}
                    onKeyDown={(e) => {
                      // Handle backspace to move to previous field
                      if (
                        e.key === "Backspace" &&
                        !otpValue[index] &&
                        index > 0
                      ) {
                        document
                          .getElementById(`otp-input-${index - 1}`)
                          .focus();
                      }
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      const pastedData = e.clipboardData.getData("text").trim();
                      if (/^\d{5}$/.test(pastedData)) {
                        // Valid 5-digit OTP pasted
                        setOtpValue(pastedData);
                        // Optionally focus last field or blur
                        setTimeout(() => {
                          document.getElementById(`otp-input-4`)?.focus();
                        }, 0);
                      } else if (
                        /^\d+$/.test(pastedData) &&
                        pastedData.length < 5
                      ) {
                        // Partial digits: fill from current index onward
                        const newOtp = otpValue.split("");
                        let pasteIndex = index;
                        for (let char of pastedData) {
                          if (pasteIndex < 5) {
                            newOtp[pasteIndex] = char;
                            pasteIndex++;
                          }
                        }
                        setOtpValue(newOtp.join(""));
                        // Focus next empty field or last filled
                        const nextFocus = Math.min(pasteIndex, 4);
                        setTimeout(() => {
                          document
                            .getElementById(`otp-input-${nextFocus}`)
                            ?.focus();
                        }, 0);
                      }
                      // Ignore non-digit or invalid pastes silently
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "20px",
                        height: "48px",
                        width: "48px",
                        textAlign: "center",
                        "& fieldset": {
                          borderColor: "#d0d0d0",
                          borderWidth: "2px",
                        },
                        "&:hover fieldset": {
                          borderColor: "#2a7fd4",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#2a7fd4",
                          borderWidth: "2px",
                        },
                      },
                      "& input": {
                        padding: "0",
                        textAlign: "center",
                      },
                    }}
                    id={`otp-input-${index}`}
                    autoFocus={index === 0}
                  />
                ))}
              </Box>
            </Box>

            {/* Action Buttons */}
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  variant="outlined"
                  color="error"
                  fullWidth
                  onClick={() => {
                    setOpenOTPModal(false);
                    setOtpValue("");
                    setOtpError("");
                    setCurrentSubOrderForOTP(null);
                    setIsVerifyingOTP(false);
                  }}
                  sx={{
                    py: 1.5,
                    borderRadius: "20px",
                    textTransform: "none",
                    fontWeight: 500,
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="success"
                  fullWidth
                  onClick={async () => {
                    // Validate OTP format
                    if (!/^\d{5}$/.test(otpValue)) {
                      setOtpError("Please enter a valid 5-digit OTP");
                      return;
                    }

                    setIsVerifyingOTP(true);

                    try {
                      // API CALL - Verify OTP
                      const response = await axios.post(
                        `${process.env.REACT_APP_SECRET}/api/DeliveryPortal/VerifyOTPAndInsertOrderApprovalByRestaurant`,
                        {
                          orderId: String(order.id),
                          subOrderId: String(currentSubOrderForOTP.id),
                          otp: otpValue,
                          approverId: userId,
                          confirmationMethod: "OTP",
                        },
                      );

                      // Check response for OTP mismatch
                      if (
                        response.data === "OTP Not Match" ||
                        response.data?.includes?.("OTP Not Match")
                      ) {
                        setOtpError("Invalid OTP. Please check and try again.");
                        setOtpValue("");
                        toast.error(
                          "Invalid OTP. Please check and try again.",
                          {
                            position: "top-right",
                            autoClose: 3000,
                            theme: "colored",
                          },
                        );
                        return;
                      }

                      // SUCCESS - OTP verified
                      toast.success(
                        "OTP verified! Order marked as collected.",
                        {
                          position: "top-right",
                          autoClose: 2500,
                          theme: "colored",
                        },
                      );

                      // Update order status
                      handleOrderStatusChangeAtCollect();

                      // Clean up modal
                      setOpenOTPModal(false);
                      setOtpValue("");
                      setOtpError("");
                      setCurrentSubOrderForOTP(null);
                    } catch (error) {
                      console.error("OTP verification failed:", error);

                      // Error handling
                      let errorMessage =
                        "Verification failed. Please try again.";

                      if (error.response?.status === 400) {
                        errorMessage =
                          "Invalid OTP. Please check and try again.";
                      } else if (error.response?.status === 404) {
                        errorMessage = "Order not found. Contact support.";
                      } else if (error.code === "ERR_NETWORK") {
                        errorMessage = "Network error. Check connection.";
                      }

                      setOtpError(errorMessage.replace(/❌ |🌐 /g, ""));
                      toast.error(errorMessage, {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "colored",
                      });
                    } finally {
                      setIsVerifyingOTP(false);
                    }
                  }}
                  disabled={otpValue.length < 5 || isVerifyingOTP}
                  sx={{
                    py: 1.5,
                    borderRadius: "20px",
                    textTransform: "none",
                    fontWeight: 500,
                    backgroundColor:
                      otpValue.length >= 5 ? "#2e7d32" : "#a5d6a7",
                    "&:hover": {
                      backgroundColor:
                        otpValue.length >= 5 ? "#1b5e20" : "#81c784",
                    },
                  }}
                >
                  {isVerifyingOTP ? "⏳ Verifying..." : "Verify & Collect"}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>

      {openTableEdit && (
        <OrderTableDialog
          open={openTableEdit}
          onclose={() => {
            setOpenTableEdit(false);
            reloadData();
          }}
          subOrder={selectedSubOrder}
        />
      )}
    </div>
  );
};

export default OrderDetailsCardContent;
